
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

const SelectFileForImportDisabled = ({
    readedItemsCount
}) => {

    const renderFileContent = () => {
        return (readedItemsCount > 0)
            ? (
                <div>{`Počet načtených úseků mezí ze zadaného souboru: ${readedItemsCount}`}</div>
            )
            : (
                <div>{`Zadaný soubor neobsahuje žádné úseky mezí`}</div>
            );
    }

    return (
        <Stack>
            <h3>Zadán soubor s úseky mezí</h3>
            <Stack.Item>
                {renderFileContent()}
            </Stack.Item>
        </Stack>
    );
}

export default SelectFileForImportDisabled;
